import React, { useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { HelmetProvider } from 'react-helmet-async';
import { SnackbarProvider } from 'notistack';
import { AuthProvider } from 'context/AuthContext';
import { StoreAdminProvider } from 'context/StoreAdminContext';
import { CartProvider } from 'context/CartContext';
import { CatalogPreferencesProvider } from 'context/CatalogPreferencesContext';
import { StorefrontProvider, useStorefrontContext } from 'context/StorefrontContext';
import { TenantProvider } from 'context/TenantContext';
import { OfflineProvider } from 'context/OfflineContext';
import { createStoreTheme } from 'theme';
import AppRouter from 'routes/AppRouter';

const ThemedApp: React.FC = () => {
  const { theme, colorMode } = useStorefrontContext();
  const muiTheme = useMemo(() => createStoreTheme(colorMode, theme), [colorMode, theme]);

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <AuthProvider>
        <StoreAdminProvider>
          <CartProvider>
            <CatalogPreferencesProvider>
              <BrowserRouter>
                <AppRouter />
              </BrowserRouter>
            </CatalogPreferencesProvider>
          </CartProvider>
        </StoreAdminProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

const App: React.FC = () => (
  <HelmetProvider>
    <SnackbarProvider maxSnack={3} autoHideDuration={4000}>
      <TenantProvider>
        <OfflineProvider>
          <StorefrontProvider>
            <ThemedApp />
          </StorefrontProvider>
        </OfflineProvider>
      </TenantProvider>
    </SnackbarProvider>
  </HelmetProvider>
);

export default App;
